// extracted by mini-css-extract-plugin
export var content = "_7-3";
export var footer = "_7-4";
export var header = "_7-1";
export var panel = "_7-0";
export var tabsWrapper = "_7-2";